import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/app/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "destroy"
    }}>{`Destroy`}</h1>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p><inlineCode parentName="p">{`cdflow2 [ GLOBALOPTS ] destroy [ OPTS ] ENV VERSION`}</inlineCode></p>
    <p>{`See `}<a parentName="p" {...{
        "href": "./usage"
      }}>{`usage`}</a>{` for global options.`}</p>
    <h3 {...{
      "id": "arguments"
    }}>{`Arguments:`}</h3>
    <p><inlineCode parentName="p">{`ENV`}</inlineCode>{`
: The environment containing the infrastructure being destroyed.`}</p>
    <p><inlineCode parentName="p">{`VERSION`}</inlineCode>{`
: The version to destroy (must match a pre-existing release).`}</p>
    <h3 {...{
      "id": "options"
    }}>{`Options:`}</h3>
    <p><inlineCode parentName="p">{`--plan-only`}</inlineCode>{` | `}<inlineCode parentName="p">{`-p`}</inlineCode>{`
: Generate an execution plan only, don't destroy.`}</p>
    <p><inlineCode parentName="p">{`--terraform-log-level`}</inlineCode>{` | `}<inlineCode parentName="p">{`-t`}</inlineCode>{`
: Set Terraform log level (TF_LOG), useful for debugging.`}</p>
    <h2 {...{
      "id": "description"
    }}>{`Description`}</h2>
    <p>{`Terraform is configured as described in `}<a parentName="p" {...{
        "href": "common-terraform-setup"
      }}>{`common terraform setup`}</a>{`, followed by commands
equivalent to:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell-session"
      }}>{`$ cd infra
$ terraform plan -destroy \\
    -var-file=/build/release-metadata.json
$ 
$ terraform destroy -auto-approve \\
    -var-file=/build/release-metadata.json
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      